import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49a0603e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "restrictedCitySet" }
const _hoisted_2 = { class: "contain" }
const _hoisted_3 = { class: "header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "BU", -1))
const _hoisted_5 = { class: "main" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Edit")
const _hoisted_8 = { class: "table" }
const _hoisted_9 = { style: {"padding-top":"20px","padding-bottom":"12px"} }
const _hoisted_10 = { class: "content" }
const _hoisted_11 = { class: "handler-table" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "btn" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Cancel")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_Title = _resolveComponent("Title")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Breadcrumb, { dataSource: [{ name: 'restricted city set' }] }),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _hoisted_4,
            _createVNode(_component_a_select, {
              value: _ctx.bu,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.bu) = $event)),
              onChange: _ctx.handlerBuChange
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.buList, (bu) => {
                  return (_openBlock(), _createBlock(_component_a_select_option, {
                    value: bu.label,
                    key: bu.label,
                    title: bu.label
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(bu.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["value", "title"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["value", "onChange"])
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_Title, { text: 'Restricted city set' }),
            (_ctx.$btnPermissions('Local City Edit'))
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 0,
                  type: "primary",
                  onClick: _ctx.handleEdit
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_a_table, {
              columns: _ctx.columns,
              dataSource: _ctx.data,
              rowKey: "id",
              bordered: "",
              pagination: false,
              rowClassName: 
                            (record, index) =>
                                index % 2 === 1 ? 'table-striped' : null
                        
            }, null, 8, ["columns", "dataSource", "rowClassName"])
          ])
        ])
      ])
    ]),
    _createVNode(_component_a_drawer, {
      title: "Edit",
      visible: _ctx.isEditing,
      width: "58%",
      bodyStyle: { paddingTop: '5px' },
      onClose: _ctx.handleClose
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_Title, { text: 'Restricted city set' })
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_a_table, {
              columns: _ctx.handlerColumns,
              dataSource: _ctx.handlerData,
              rowKey: "id",
              bordered: "",
              pagination: false,
              rowClassName: 
                        (record, index) =>
                            index % 2 === 1 ? 'table-striped' : null
                    
            }, {
              province: _withCtx(({ record }) => [
                _createVNode(_component_a_select, {
                  value: record.province,
                  "onUpdate:value": ($event: any) => ((record.province) = $event),
                  onChange: ($event: any) => (_ctx.handlerProvinceChange($event, record)),
                  filterOption: _ctx.filterOption,
                  "show-search": ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.provinceList, (province) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        value: province.name,
                        key: province.name,
                        title: province.name
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(province.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["value", "title"]))
                    }), 128))
                  ]),
                  _: 2
                }, 1032, ["value", "onUpdate:value", "onChange", "filterOption"])
              ]),
              city: _withCtx(({ record }) => [
                _createVNode(_component_a_select, {
                  value: record.city,
                  "onUpdate:value": ($event: any) => ((record.city) = $event),
                  disabled: !record.province,
                  onChange: ($event: any) => (_ctx.handleSave(record)),
                  filterOption: _ctx.filterOption,
                  "show-search": ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.cityList, (city) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        value: city.name,
                        key: city.name,
                        title: city.name
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(city.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["value", "title"]))
                    }), 128))
                  ]),
                  _: 2
                }, 1032, ["value", "onUpdate:value", "disabled", "onChange", "filterOption"])
              ]),
              restrictionFrom: _withCtx(({ record }) => [
                _createVNode(_component_a_date_picker, {
                  value: record.restrictionFrom,
                  "onUpdate:value": ($event: any) => ((record.restrictionFrom) = $event),
                  onChange: ($event: any) => (_ctx.handleSave(record))
                }, null, 8, ["value", "onUpdate:value", "onChange"])
              ]),
              restrictionTo: _withCtx(({ record }) => [
                _createVNode(_component_a_date_picker, {
                  value: record.restrictionTo,
                  "onUpdate:value": ($event: any) => ((record.restrictionTo) = $event),
                  onChange: ($event: any) => (_ctx.handleSave(record))
                }, null, 8, ["value", "onUpdate:value", "onChange"])
              ]),
              operation: _withCtx(({ record, index }) => [
                _createElementVNode("a", {
                  class: "delete-btn",
                  onClick: ($event: any) => (_ctx.handleRemove(record, index))
                }, "Delete", 8, _hoisted_12)
              ]),
              _: 1
            }, 8, ["columns", "dataSource", "rowClassName"])
          ]),
          _createElementVNode("div", {
            class: "add",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleAdd && _ctx.handleAdd(...args)))
          }, "+ add"),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: _ctx.handleClose
            }, {
              default: _withCtx(() => [
                _hoisted_14
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "onClose"])
  ], 64))
}